import styled from 'particles/themes/styled'

export type ToggleButtonSize = 's' | 'm'

const sizeMap: Record<
    ToggleButtonSize,
    { toggleWidth: string; toggleHeight: string; iconOffset: string; buttonOffset: string; buttonSize: string }
> = {
    m: {
        toggleWidth: '42px',
        toggleHeight: '20px',
        iconOffset: '8px',
        buttonOffset: 'translateX(22px)',
        buttonSize: '16px',
    },
    s: {
        toggleWidth: '32px',
        toggleHeight: '16px',
        iconOffset: '6px',
        buttonOffset: 'translateX(16px)',
        buttonSize: '12px',
    },
}

interface ContainerProps {
    size: ToggleButtonSize
    width?: number
}

export const ToggleContainer = styled.div<ContainerProps>`
    width: ${({ size }) => sizeMap[size].toggleWidth};
    height: ${({ size }) => sizeMap[size].toggleHeight};
    border-radius: 30px;
    padding: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.surface.neutralAction};
    position: relative;
    box-sizing: border-box;
    margin-top: 3px;
    .toggle {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .check {
        left: ${({ size }) => sizeMap[size].iconOffset};
    }
    .unchecked {
        right: ${({ size }) => sizeMap[size].iconOffset};
    }

    .switch-button {
        position: absolute;
        left: 2px;
        z-index: 200;
    }
    .hidden {
        opacity: 0;
        transition: 0.3s opacity;
    }

    &.on {
        background-color: ${({ theme }) => theme.colors.surface.positive};
        .switch-button {
            transform: ${({ size }) => sizeMap[size].buttonOffset};
        }
    }
    &.disabled {
        cursor: not-allowed;
        background-color: ${({ theme }) => theme.colors.surface.disable};
    }
`

interface SwitchButtonProps {
    size: ToggleButtonSize
}

export const SwitchButton = styled.div<SwitchButtonProps>`
    width: ${({ size }) => sizeMap[size].buttonSize};
    height: ${({ size }) => sizeMap[size].buttonSize};
    border-radius: 50%;
    border: none;
    transition: 0.3s transform;
    background-color: ${({ theme }) => theme.colors.surface.actionInverse};
    cursor: pointer;
    &.disabled {
        cursor: not-allowed;
    }
    &:focus-visible {
        outline-offset: -2px;
        outline: 1.25px solid ${({ theme }) => theme.colors.border.actionFocus};
    }
`

export const Container = styled.div<ContainerProps>`
    display: grid;
    align-items: flex-start;
    grid-template-columns: auto 1fr;
    gap: ${({ theme }) => theme.spacing[200]};
    .text-container {
        display: flex;
        flex-direction: column;
        white-space: pre-wrap;
    }
    .readonly-text {
        width: ${({ size }) => sizeMap[size].toggleWidth};
        text-align: center;
    }
`
